<template>
    <v-container >
        <v-row class="ma-0">
            <v-col cols="2">
                <v-btn icon to="/">
                    <v-icon>
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
            </v-col>
            <v-col cols="8">
                <v-row class="ma-0">
                    <v-spacer/>
                    <div style="font-weight:500; font-size:21px; line-height:30px; font-weight:300; font-family: 'Ergon'!important;">COLABORACIONES</div>
                    <v-spacer/>
                </v-row>
            </v-col>
            <v-col cols="2">
            </v-col>
        </v-row>

        <v-row class="ma-0">
            <v-card class="px-2 elevation-0" style="background:transparent;">
                <v-card-subtitle class="ma-0 pa-0 pt-2" style="color:black!important; ">
                    Cobrado
                    <br/>
                    <span v-if="card.received!=undefined" style="font-size:25px; line-height:32px; font-weight:600; color:black!important;">{{(card.received*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</span>
                    <v-skeleton-loader v-else type="text" width="180" style="margin-top: 6px !important;"></v-skeleton-loader>
                </v-card-subtitle>
                <v-card-subtitle class="ma-0 pa-0 pt-0" style="color:black!important; ">
                        Pendientes
                        <strong v-if="card.pending!=undefined">{{(card.pending*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                        <v-skeleton-loader v-else type="text" width="120" style="margin-top: 6px !important;"></v-skeleton-loader>
                </v-card-subtitle>
                <v-card-subtitle class="ma-0 pa-0 pt-0" style="color:black!important; ">
                        Sin Fecha de Cierre
                        <strong v-if="card.total!=undefined">{{(card.total*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                        <v-skeleton-loader v-else type="text" width="120" style="margin-top: 6px !important;"></v-skeleton-loader>
                </v-card-subtitle>
            </v-card>
            <v-spacer/>
            <v-avatar size="60px">
                <v-img alt="user" src="/cropped-Favicon-PeachAgency2.png"></v-img>
            </v-avatar>
        </v-row>

        <v-row class="ma-0 px-6 py-4">
            <v-progress-linear :value="((100/((card.received*1)+(card.pending*1)))*card.received)"></v-progress-linear>
        </v-row>

        <v-row class="ma-0 custom-date-picker">
            <v-spacer/>
            <v-menu offset-y :close-on-content-click="closeDatePicker">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn rounded style=" font-weight:600; color:#f4d6c9;" class="elevation-0 mt-2" color="primary" dark v-bind="attrs" v-on="on">
                        <v-icon class="mr-2" small>mdi-calendar-blank</v-icon>{{selectedPeriod}}
                    </v-btn>
                </template>
                <v-date-picker type="month" v-model="selectedPeriod2" range></v-date-picker>
                <br/>
                <v-row class="ma-0">
                    <v-spacer/>
                    <v-btn @click="selectedPeriod2=[]" rounded color="primary" small class="elevation-0 mb-2">Sin Fecha de Cierre</v-btn>
                    <v-spacer/>
                </v-row>
            </v-menu>


            <v-spacer/>
        </v-row>
        <div v-if="false && show_pestañita" style="width:calc(100vw - 24px); position:absolute; bottom:0px;">
            <v-row class="ma-0">
                <v-btn style="margin: auto auto 80px; background: white; border-radius: 10px 10px 0px 0px; width: 100px;" icon @click="half">
                    <v-icon large>mdi-chevron-up</v-icon>
                </v-btn>
            </v-row>
        </div>

        <swipeable-bottom-sheet ref="swipeableBottomSheet">
            <v-card style="background:transparent;" class="elevation-0 py-0 px-2" v-for="collab in collabs" :key="collab.id" @click="openCollab(collab)">
                <v-row class="ma-0" style="color:black!important;">
                    <v-col cols="6" class="pa-0">
                        <v-card-title class="pb-0" style="font-size:16px; font-weight:300; font-family: 'Ergon'!important;">{{collab.brand}}</v-card-title>
                        <v-chip x-small class="ml-4" color="primary" style="font-family:'Tomato Grotesk'!important;">{{date(collab.influencer_payment_date, collab.payment_promise_date, collab.deadline_date)}}</v-chip>
                    </v-col>
                    <v-col cols="6" class="pa-0" style="text-align:right;">
                        <v-card-title style="font-family:'Tomato Grotesk'!important;" :style="'font-size:17px; display: block; font-weight:600;' + color(collab.influencer_payment_date)">{{(collab.influencer_amount*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                        <v-card-subtitle style="font-family:'Tomato Grotesk'!important;" :style="(collab.collab_status=='Pagado al Talento' || collab.collab_status=='Pagado por la Marca' ? 'font-weight:600; ' : '') + 'font-size:13px; color:' + colorStatus(collab.collab_status) + ';'">{{collab.collab_status}}</v-card-subtitle>
                    </v-col>
                </v-row>
                <v-divider/>
            </v-card>
            <v-card style="background:transparent;" class="elevation-0 py-0 px-2 mt-6" v-if="collabsDateNull.length>0">
                <v-row class="ma-0">
                    <v-spacer/>
                    <v-card-subtitle class="pb-2" style="font-family:'Tomato Grotesk'!important;">SIN FECHA DE CIERRE</v-card-subtitle>
                    <v-spacer/>
                </v-row>
                <v-divider/>
            </v-card>
            <v-card style="background:transparent;" class="elevation-0 py-0 px-2" v-for="collab in collabsDateNull" :key="collab.id" @click="openCollab(collab)">
                <v-row class="ma-0" style="color:grey!important;">
                    <v-col cols="6" class="pa-0">
                        <v-card-title style="font-family: 'Ergon'!important; font-size:16px; font-weight:300;">{{collab.brand}}</v-card-title>
                    </v-col>
                    <v-col cols="6" class="pa-0" style="text-align:right;">
                        <v-card-title style="font-family:'Tomato Grotesk'!important; font-size:17px; display: block; font-weight:600;">{{(collab.influencer_amount*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                    </v-col>
                </v-row>
                <v-divider/>
            </v-card>
            <div style="height:220px;"></div>
        </swipeable-bottom-sheet>
        
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <div style="background:#f4f5fb!important;" class="pa-4">
                <v-card class="elevation-0" style="border-radius:0px;!important; border:solid 1px #111111; min-height:calc(100vh - 30px);">
                    <v-card  class="elevation-0 px-4">
                        <v-row class="elevation-0 pt-4 mt-0">
                            <v-spacer/>
                            <v-btn icon @click="closeDialog()">
                                <v-icon>
                                    mdi-chevron-down
                                </v-icon>
                            </v-btn>
                            <v-spacer/>
                        </v-row>
                        <v-row class="my-0 mx-4">
                            <div>
                                <v-card-title style="font-size:25px; font-family: 'Ergon'!important; font-weight:300;">{{collab.brand}}</v-card-title>
                                <v-card-subtitle>{{date(collab.influencer_payment_date, collab.payment_promise_date)}}</v-card-subtitle>
                            </div>
                            <v-spacer/>
                            <v-avatar size="60px" class="mt-4">
                                <v-img alt="user" src="/cropped-Favicon-PeachAgency2.png"></v-img>
                            </v-avatar>
                        </v-row>
                        <v-chip class="ml-4" style="border-radius:50px!important; padding:18px 21px;" dark :color="colorStatus(collab.collab_status)">{{collab.collab_status}}</v-chip>
                    </v-card>

                    <v-row class="ma-0 px-4 mt-5">
                        <v-card-subtitle style="font-size:16px;">Subtotal</v-card-subtitle>
                        <v-spacer/>
                        <v-card-subtitle style="font-size:16px;">{{(collab.influencer_amount - (collab.influencer_amount*.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-subtitle>
                    </v-row>

                    <v-row class="ma-0 px-4">
                        <v-card-subtitle style="font-size:16px;" class="py-0">IVA</v-card-subtitle>
                        <v-spacer/>
                        <v-card-subtitle style="font-size:16px;" class="py-0">{{(collab.influencer_amount*.16).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-subtitle>
                    </v-row>
                    
                    <v-row class="ma-0 px-4 mb-5">
                        <v-card-title style="font-size:24px;">Monto</v-card-title>
                        <v-spacer/>
                        <v-card-title style="font-size:24px;">{{(collab.influencer_amount*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</v-card-title>
                    </v-row>
                        
                    <v-card class="elevation-0 py-4 px-6 mx-7" style="border-radius:20px; background-color: #f9efe8!important; font-size:14px;">
                        <v-row class="ma-0">
                            <strong>SERVICIO</strong>
                            <v-spacer/>
                            {{collab.service}}
                        </v-row>
                        <v-divider class="my-3"/>
                        <v-row class="ma-0">
                            <strong>CAMPAÑA</strong>
                            <v-spacer/>
                            {{collab.campaign}}
                        </v-row>
                    </v-card>

                    <v-row class="ma-8" v-if="collab.campaign_status!=null">
                        <v-card-subtitle style="" class="ma-0 pa-0 mr-4 mt-1">Estatus de Campaña</v-card-subtitle>
                        <v-chip style=""  :color="campaign_statuses.filter(c=>c.value==collab.campaign_status).map(c=>c.chipColor)[0]" :style="'color:'+campaign_statuses.filter(c=>c.value==collab.campaign_status).map(c=>c.textColor)[0]+'!important;'">{{collab.campaign_status}}</v-chip>
                    </v-row>


                    <v-row class="ma-8" v-if="collab.collection_status!=null">
                        <v-card-subtitle style="" class="ma-0 pa-0 mr-4 mt-1">Estatus de Cobranza</v-card-subtitle>
                        <v-chip style=""  :color="collection_statuses.filter(c=>c.value==collab.collection_status).map(c=>c.chipColor)[0]" :style="'color:'+collection_statuses.filter(c=>c.value==collab.collection_status).map(c=>c.textColor)[0]+'!important;'">{{collab.collection_status}}</v-chip>
                    </v-row>

                    <v-row class="ma-8" v-if="collab.voucher_file!=null">
                        <v-btn v-bind:href="'https://peach.blitzhub.mx/files/' + collab.voucher_file" target="_blank" class="elevation-0" rounded color="primary" small>
                            <v-icon small class="mr-2">mdi-download</v-icon>
                            Comprobante de Pago
                        </v-btn>
                    </v-row>
                    
                </v-card>
            </div>
        </v-dialog>
    </v-container>
</template>

<script>
import dates from '../../mixins/dates'
import { SwipeableBottomSheet } from "vue-swipeable-bottom-sheet";

export default {
    mixins: [dates],
    components: {
        SwipeableBottomSheet
    },
    data(){
        return{
            selectedPeriod:[],
            selectedPeriod2:[],
            dialog: false,
            collab:{},
            period:[],
            show_pestañita: false,
            campaign_statuses:[
                {
                    "value": "POR INICIAR",
                    "description": "La campaña aún no empieza.",
                    "chipColor": "#cdeee0",
                    "textColor": "#2b2b2b"
                }
            ],
            collection_statuses:[
                {
                    "value": "LEGAL",
                    "description": "La venta se encuentra en proceso legal para ser pagada.",
                    "chipColor": "#ecd3d3",
                    "textColor": "#a20000"
                },
                {
                    "value": "FACTURADO",
                    "description": "Ya se envió la factura al cliente.",
                    "chipColor": "#dcd6ea",
                    "textColor": "#2b2b2b"
                },
                /*{
                    "value": "PÚBLICO EN GENERAL",
                    "description": "Se tiene que facturar a público en general.",
                    "chipColor": "#e2cfdc",
                    "textColor": "#2b2b2b"
                },*/
                {
                    "value": "PAGO EN EFECTIVO",
                    "description": "El pago se realiza en efectivo.",
                    "chipColor": "#dce7d5",
                    "textColor": "#2b2b2b"
                },
                /*{
                    "value": "FACTURA AGENDADA",
                    "description": "Se tiene fecha programada para generar la factura.",
                    "chipColor": "#d5dee4",
                    "textColor": "#2b2b2b"
                },*/
                {
                    "value": "REVISANDO ESTATUS",
                    "description": "Se están revisando los detalles de pago.",
                    "chipColor": "#eef4c8",
                    "textColor": "#2b2b2b"
                },
                {
                    "value": "POR INICIAR",
                    "description": "La campaña aún no empieza.",
                    "chipColor": "#cdeee0",
                    "textColor": "#2b2b2b"
                },
                {
                    "value": "RED FLAG",
                    "description": "Sin respuesta del cliente.",
                    "chipColor": "#e5dfd0",
                    "textColor": "#2b2b2b"
                },
                {
                    "value": "PAGADO POR MARCA",
                    "description": "",
                    "chipColor": "#d5dee4",
                    "textColor": "#2b2b2b"
                },
            ],
        }
    },
    watch:{
        collabs:{
            handler(){
                this.show_pestañita = true
            }, deep: true,
        },
        selectedPeriod2:{
            handler(){
                if(this.selectedPeriod2.length==2){
                    const period = [
                        new Date(new Date(this.selectedPeriod2[0]+'-15').getFullYear(), new Date(this.selectedPeriod2[0]+'-15').getMonth(), 1).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10),
                        new Date(new Date(this.selectedPeriod2[1]+'-15').getFullYear(), new Date(this.selectedPeriod2[1]+'-15').getMonth() + 1, 0).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
                    ]
                    const ordered_period = period.sort(function(a,b){
                        return new Date(a) - new Date(b);
                    });
                    this.period = [ordered_period[0].toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10), ordered_period[1].toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)]
                    
                    if(this.period[0] == this.period[1]){
                        this.selectedPeriod = this.monthFormat(this.period[0].slice(5, 7)).slice(0, 3) + ' ' + this.period[0].slice(0, 4)
                    }else{
                        this.selectedPeriod = this.monthFormat(this.period[0].slice(5, 7)).slice(0, 3) + ' ' + this.period[0].slice(0, 4) + ' - ' + this.monthFormat(this.period[1].slice(5, 7)).slice(0, 3) + ' ' + this.period[1].slice(0, 4)
                    }
                    this.open()
                    this.$store.dispatch('collab/getCard', {from:this.period[0], to:this.period[1]})
                    this.$store.dispatch('collab/getCollabs', {date_between:this.period})
                }else{
                    this.$store.dispatch('collab/getCollabsWithoutDeadlineDate')
                }
            }, deep: true,
        },
    },
    created(){
        var startDate = []
        var date = new Date()
        startDate[0] = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)

        startDate[1] = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)

        this.$store.dispatch('collab/getCard', {from:startDate[0], to:startDate[1]})
        this.$store.dispatch('collab/getCollabs', {date_between: startDate})

        console.log(this.period)
        
        if(this.period[0] == this.period[1]){
            this.selectedPeriod = this.monthFormat(startDate[0].slice(5, 7)).slice(0, 3) + ' ' + startDate[0].slice(0, 4)
        }else{
            this.selectedPeriod = this.monthFormat(startDate[0].slice(5, 7)).slice(0, 3) + ' ' + startDate[0].slice(0, 4) + ' - ' + this.monthFormat(startDate[1].slice(5, 7)).slice(0, 3) + ' ' + startDate[1].slice(0, 4)
        }

    },
    computed:{
        closeDatePicker(){
            if(this.selectedPeriod2!=null){
                if(this.selectedPeriod2.length==2){
                    return true
                }else{
                    return false
                }
            }else{
                this.selectedPeriod = []
            }
        },
        loader(){
            return this.$store.state.collab.loading
        },
        collabsDateNull(){
            const collabs = this.$store.state.collab.collabs
            return  typeof(collabs[0])=='object'?collabs.filter(collab=>collab.deadline_date==null):collabs//collab.influencer_payment_date==null && collab.payment_promise_date==null):collabs
        },
        collabs(){
            const collabs = this.$store.state.collab.collabs
            return  typeof(collabs[0])=='object'?collabs.filter(collab=>collab.deadline_date!=null):collabs//collab.influencer_payment_date!=null || collab.payment_promise_date!=null):collabs
        },
        total(){
            return  this.$store.state.collab.total
        },
        card(){
            return this.$store.state.collab.card
        },
        cardLoader(){
            return this.$store.state.collab.loading_card
        },
    },
    methods: {
        startDate(start, end){
            var startDate = []
            var date = new Date()
            startDate[0] = new Date(date.getFullYear(), date.getMonth() + start, 1).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
            startDate[1] = new Date(date.getFullYear(), date.getMonth() + end, 0).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
            return startDate
        },
        openCollab(collab){
            this.collab = collab
            this.dialog = true
        },
        closeDialog(){
            this.collab = {}
            this.dialog = false
        },
        color(date){
            if(date==null){
                return 'color:black!important;'
            }else{
                return 'color:black!important;'
            }
        },
        colorStatus(collab_status){
            if(collab_status=='Pendiente'){
                return '#595959'
            }else if(collab_status=='Pagado al Talento') {
                return "#f4a17b"
            }
            else if(collab_status=='Pagado por la Marca') {
                return "#ffbf00"
            }
        },
        date(influencer_payment_date, payment_promise_date, deadline_date){
            if(influencer_payment_date!=null){
                return this.dateFormat(influencer_payment_date)
            }else if(payment_promise_date!=null){
                return this.dateFormat(payment_promise_date)
            }else if(deadline_date!=null){
                return this.dateFormat(deadline_date.slice(8,10) + '-' + deadline_date.slice(5,7) + '-' + deadline_date.slice(0,4))
            }else{
                return 'SIN FECHA DE CIERRE'
            }
        },
        half () {
            this.$refs.swipeableBottomSheet.setState("half")
        },
        open () {
            this.$refs.swipeableBottomSheet.setState("open")
        },
        close () {
            this.$refs.swipeableBottomSheet.setState("close")
        }
    }

}
</script>

<style>
    [data-state="half"]{
        top:320px!important;
    }
    [data-state="open"]{
        top:70px!important;
    }
    .pan-area[data-v-5d6b6420] {
        padding: 12px 0 20px 0!important;
    }
    .v-picker__title__btn.v-date-picker-title__date.v-picker__title__btn--active{
        display: none;
    }
    .card[data-v-5d6b6420]{
        box-shadow:none!important;
        background: #f8efe9 !important;
        width: calc(100vw - 36px) !important;
        margin-left: 18px;
    }
    .bar[data-v-5d6b6420] {
        background: #f59f7a !important;
    }



    
        .v-picker__title{
            display:none!important;
        }
        .theme--light.v-card,
        .theme--light.v-picker__body {
            background: #F4F4F400 !important;  
        }
        .v-application .accent {
            background-color: transparent !important;
            border-color: #f4895a !important;
            color: #f4895a !important;
            border-radius: 50px!important;
            border-width: 2px !important;
        }
        .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
            color: rgb(244 137 90)!important;
            font-family: 'Ergon'!important;
            font-weight: 300;
        }
        .v-application .accent--text {
            color: #f4895a !important;
            caret-color: #f4895a !important;
            border-radius: 50px!important;
        }
        .v-menu__content.theme--light.menuable__content__active{
            border-radius: 30px;
            background: #fde8d9!important;
        }
        .v-picker.v-card.v-picker--date.theme--light{
            border: solid 1px #f4895a;
            margin: 7px;
            border-radius: 30px;
        }
        
        .theme--light.v-divider {
            border-color: #f4895a!important;
        }
</style>